import { almacenesSections } from './almacenesSections';

export const almacenesManual = {
  id: 'mod-almacenes',
  title: 'Almacenes',
  isVisible: (ctx) => ctx.limitedScope.showAlmacenes,
  intro:
    'Inventario: selección de almacén, documentos y guías de movimiento (ingreso, salida, traslado, recepción, ajuste, inicial), kardex y reportes. Incluye «Grilla de productos e ítems — Almacenes» enlazada a la guía transversal en Inicio y acceso. Cada función del menú está documentada con la plantilla de 12 apartados.',
  sections: almacenesSections,
};
